import parse, { domToReact, Element, HTMLReactParserOptions } from 'html-react-parser';
import Link from 'next/link';
import clsx from 'clsx';
import SlideUp from '@/common/utils/slideUp';

type TextRendererProps = {
  text: string;
  as?: 'div' | 'section';
  color?: 'white' | 'chocolate';
};

const options: HTMLReactParserOptions = {
  replace: (domNode) => {
    if (domNode instanceof Element && domNode.name === 'a') {
      const href = domNode.attribs?.href;
      const anchorClasses = 'font-medium';

      if (href?.includes(`${process.env.NEXT_PUBLIC_PROD_URL}`)) {
        return (
          <Link className={anchorClasses} href={href}>
            {domToReact(domNode.children as Element[])}
          </Link>
        );
      }
      return (
        <a className={anchorClasses} href={href} target="_blank" rel="noopener noreferrer">
          {domToReact(domNode.children as Element[])}
        </a>
      );
    }
  },
};

const colon = / :/g;
const exclamation = / !/g;
const question = / \?/g;
const semicolon = / ;/g;

export const TextRenderer = ({ text, as, color }: TextRendererProps) => {
  const textReplace = text
    ?.replace(colon, '&nbsp;:&nbsp;')
    .replace(exclamation, '! ')
    .replace(question, '? ')
    .replace(semicolon, '; ');

  const Tag = as ?? 'div';

  return (
    text && (
      <SlideUp yOffset={0}>
        <Tag
          className={clsx(
            'prose min-w-fit prose-p:text-lg prose-strong:font-bold prose-p:font-libertineRegular prose-p:font-normal',
            'prose-strong:font-bold prose-ul:-ml-2 prose-li:font-libertineRegular ',
            'prose-h2:text-3xl prose-h2:text-dacquoise prose-h2:uppercase prose-h2:font-stigsaMedium prose-h2:font-bold',
            {
              'prose-p:text-inherit text-inherit prose-strong:text-inherit prose-li:text-inherit prose-li:marker:text-inherit prose-p:leading-[24px]':
                !color,
              'prose-p:text-white text-white prose-strong:text-white prose-li:text-white prose-li:marker:text-white prose-p:leading-[22px]':
                color === 'white',
              'prose-p:text-chocolate text-chocolate prose-strong:text-chocolate prose-li:text-chocolate prose-li:marker:text-chocolate prose-p:leading-[24px]':
                color === 'chocolate',
            }
          )}
        >
          {parse(textReplace, options)}
        </Tag>
      </SlideUp>
    )
  );
};
